<template>
  <div class="service-item-landscape round-corner" @click="service ? serviceJump(service) : locationTo(linkUrl)">
    <div class="service-content">
      <p class="service-name">{{service.name}}</p>
      <div class="tags">
        <van-tag v-if="service.code" :color="mainColorLight" :text-color="mainColor" size="large">{{service.code}}</van-tag>
        <van-tag v-if="way" :color="mainColorLight" :text-color="mainColor" size="large">{{way}}</van-tag>
        <van-tag v-if="obj" :color="mainColorLight" :text-color="mainColor" size="large">{{obj}}</van-tag>
      </div>
    </div>
  </div>
</template>

<script>
  import {Tag} from 'vant';
  import {fetchRgbColer} from '@/utils/commons'
  import {mapState} from "vuex"
  import {getThemeParams} from "@/utils/theme";
  import {serviceJump} from "@/utils/serviceUtil"
  import {locationTo} from "@/utils/url"
	export default {
		name: 'ServiceItemLandscape',
    props: {
      service: {
        type:Object,
        default: () => {
          return {
            name: undefined,
            code: undefined
          }
        }
      },
      linkUrl:{
        type: String,
        default: ''
      }
    },
    components:{
      'van-tag':Tag,
    },
		data() {
			return {
			}
		},
		computed: {
      ...mapState(['serviceWays','serviceObjects']),
      way(){//办理途径
        let way = null;
        if(this.service.extends && this.service.extends.entry){
          this.serviceWays.forEach(item => {
            if(item.id == this.service.extends.entry){
              way = item.transactWayName;
              return;
            }
          })

        }
        return way;
      },
      obj(){//服务对象
        let objs = [];
        if(this.service.role && this.service.role.length){
          (this.service.role).forEach(role=>{
            (this.serviceObjects).forEach(item => {
              let objectRoles = item.objectRole.split(',');
              if(objectRoles.includes(role.roleid)){
                objs.push(item.objectName);
              }
            })
          })
        }
        objs = Array.from(new Set(objs))
        let obj = objs.length>0?objs.join("+"):null;
        return obj;
      },
		  mainColor(){
        if (getThemeParams('main_color')){
          return getThemeParams('main_color');
        } else {
          return '#003c88'
        }
      },
      mainColorLight(){
        let rgb = fetchRgbColer(this.mainColor)
        return 'rgba('+rgb.join(',')+',0.08)'
      }
		},
		methods: {
      fetchRgbColer,
      getThemeParams,
      serviceJump,
      locationTo
		},
		mounted() {

		}
	}
</script>

<style scoped lang="scss">
@import "~@/assets/css/theme/theme.scss";
  .service-item-landscape{
    height: 90px;
    padding: 20px 15px;
    margin-bottom: 12px;
    box-sizing: border-box;
    border-radius: 6px;
    background: #ffffff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    .service-content{
      width: 100%;
      flex:1;
      .service-name {
        @extend .font16;
        margin-bottom: 10px;
        font-size: $base-fontsize16;
        line-height: 24px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .tags {
        height: 24px;
        .van-tag {
          float: left;
          font-size: $base-fontsize12;
          margin-right: 5px;
          @extend .font13;
        }
      }
    }

    &.blur {
      filter: grayscale(100%);//IE浏览器
      -webkit-filter: grayscale(100%);//谷歌浏览器
      -moz-filter: grayscale(100%);//火狐
      -o-filter: grayscale(100%);
      filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
      -webkit-filter: grayscale(1);//谷歌浏览器
      background-color: #F0F0F0;

      .service-name {
        color: #999;
      }

      .van-tag {
        color:#999 !important;
      }
    }
  }
</style>
